// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d1f7b353","313":"ff76ed1c","413":"e8549eca","438":"0cc863d6","557":"78fdd1f6","601":"80349059","607":"d03b4e88","642":"8f738db9","830":"44364cb1","883":"d496d92a"}[chunkId] + ".chunk.js";
};